import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {graphql} from 'gatsby'
import { FormattedMessage, useIntl } from "gatsby-plugin-intl"
import Layout from '../components/Layout'
import BreadCrumb from '../components/Breadcrumb'
import category_master, { get_title } from '../misc/category_master';
import { is_development } from '../misc/util';
import { Link } from '../components/Link';

function get_articles_by_category(category_articles) {
  const r = {};
  category_articles.edges.forEach(edge => {
    const slug = edge.node.fields.slug;
    const categories = slug.split('/');
    if (!(categories[2] in r)) {
      r[categories[2]] = [];
    }
    r[categories[2]].push(edge.node);
  });
  return r;
}

const Article = (props) => {
  const { pageContext, data } = props;
  const { category1, language } = pageContext;
  const { category_articles } = data;
  const paths = [category1];
  const articles_by_category = get_articles_by_category(category_articles);

  const intl = useIntl();
  const title = `${intl.formatMessage({id: get_title(paths)})} | ${intl.formatMessage({id: 'SocialDogヘルプ'})}`;
  const description = intl.formatMessage({
    id: 'SocialDogのヘルプ。ツイート管理、フォロワー、キーワードモニター、メンション、フォロー、ミュートなどの機能や使い方、有料プラン、Twitterアカウント連携の管理についてなどの記事があります。'
  });

  const function_categories = category_master.function;

  return (
    <Layout language={language}>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta property="twitter:title" content={title} />
        <meta
          content={description}
          name="description"/>
        <meta property="og:description" content={description} />
        <meta property="twitter:description" content={description} />
      </Helmet>
      <BreadCrumb paths={paths} language={language} />
      <div id="main_container">
        <section id="main_wide">
          <h2><FormattedMessage id={get_title(paths)} /></h2>
          <p className='category_description'>
            <FormattedMessage id={category_master[paths[0]].description} />
          </p>
          <div className="category1_box_wrapper">
            {Object.keys(category_master[category1].children).map(category2 => {
              if (!articles_by_category[category2]) return null;
              return (
                <div className='category1_box'  key={category2}>
                  <div>
                    <h3>
                      <Link to={`/${category1}/${category2}/`}>
                        <FormattedMessage id={get_title([category1, category2])} />
                      </Link>
                    </h3>
                    <ul>
                      {articles_by_category[category2]?.map(node => (
                        <li key={node.fields.slug}>
                          <Link to={`${node.fields.slug}`} key={node.fields.slug}>
                            {node.frontmatter.title}
                            {is_development() && `(${node.frontmatter.order_priority})`}
                          </Link>
                        </li>
                      ))}
                    </ul>
                    <Link to={`/${category1}/${category2}/`} className='all_link'>
                      <FormattedMessage id="すべて表示" />
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </section>
      </div>
    </Layout>
  )
};

Article.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default Article

export const query = graphql`
  query ($regex: String, $language: String) {
  category_articles: allMarkdownRemark(filter: {
    fields: {slug: {regex: $regex}, lang: {eq: $language}},
  },
    sort: {order: DESC, fields: frontmatter___order_priority}
  ) {
      edges {
        node {
          frontmatter {
            title
            order_priority
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
